import { Action, createReducer, on } from '@ngrx/store';
import * as profileActions from '../actions/profile.actions';
import { IProfile } from '@scf-monorepo/interfaces';

export const profileFeatureKey = 'profile';

export interface State {
    profiles: IProfile[];
    selectedId: string;
    themeIsSet: boolean;
}

export const initialState: State = {
    profiles: [],
    selectedId: undefined,
    themeIsSet: false
};

const profileReducer = createReducer(
    initialState,
    on(profileActions.createInitialProfileSuccess, (state, { profile }) => ({
        ...state,
        profiles: [profile]
    })),
    on(profileActions.getUserProfilesSuccess, (state, { profiles }) => ({
        ...state,
        profiles
    })),
    on(profileActions.createSCDProfileSuccess, (state, { profile }) => ({
        ...state,
        profiles: [...state.profiles, profile]
    })),
    on(profileActions.copyProfileAndSetActiveSuccess, (state, { profiles }) => {
        return {
            ...state,
            profiles: changeMultipleProfiles(state.profiles, profiles)
        };
    }),
    on(profileActions.selectProfile, (state, { id }) => {
        return {
            ...state,
            selectedId: id
        };
    }),
    on(profileActions.updateProfileSuccess, (state, { profile }) => ({
        ...state,
        profiles: state.profiles.map((item) => {
            if (item.id === profile.id) {
                return profile;
            }
            return item;
        })
    })),
    on(profileActions.activateProfileSuccess, (state, { profiles }) => ({
        ...state,
        profiles: changeMultipleProfiles(state.profiles, profiles)
    })),
    on(profileActions.updateProfileFailure, (state) => ({
        ...state
    })),
    on(profileActions.deleteProfileSuccess, (state, { profile }) => ({
        ...state,
        profiles: state.profiles.filter((item) => item.id !== profile.id)
    })),
    on(profileActions.changeSelectionAndDeleteSuccess, (state, { deletedProfile, userProfile }) => {
        const previousProfiles = new Map(state.profiles.map((profile) => [profile.id, profile]));
        previousProfiles.delete(deletedProfile.id);
        previousProfiles.set(userProfile.id, userProfile);
        return {
            ...state,
            profiles: [...previousProfiles.values()]
        };
    }),
    on(profileActions.updateAdminProfileSuccess, (state, { profile }) => ({
        ...state,
        profiles: state.profiles.map((pro) => {
            if (pro.id === profile.id) {
                return profile;
            }
            return pro;
        })
    })),
    on(profileActions.setProfileValidity, (state, { profile, valid }) => ({
        ...state,
        profiles: state.profiles.map((pro) => {
            if (pro.id === profile.id && pro.isValid !== valid) {
                return { ...pro, isValid: valid };
            }
            return pro;
        })
    })),
    on(profileActions.setThemeSuccess, (state) => ({
        ...state,
        themeIsSet: true
    }))
);

export function reducer(state: State | undefined, action: Action) {
    return profileReducer(state, action);
}

function changeMultipleProfiles(stateProfiles: IProfile[], profiles: IProfile[]) {
    if (profiles) {
        const previousProfiles = new Map(stateProfiles.map((profile) => [profile.id, profile]));
        profiles.map((profile) => {
            previousProfiles.delete(profile.id);
            previousProfiles.set(profile.id, profile);
        });
        return [...previousProfiles.values()];
    }
    return stateProfiles;
}
